// ========================================
// pages/VerifyPrompt.js - Ask user to verify email
// ========================================
// PURPOSE: Displayed when user is logged in but email not verified
// - Redirects verified users to dashboard
// - Redirects non-logged in users to landing
// - Provides "Clear Session" for shared computers
// ========================================

import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const VerifyPrompt = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');
    
    // No user logged in at all - send to landing page
    if (!token || !userStr) {
      navigate('/');
      return;
    }
    
    try {
      const userData = JSON.parse(userStr);
      // User is already verified - send to dashboard
      if (userData.isEmailVerified) {
        navigate('/dashboard');
      }
    } catch (e) {
      // Invalid user data - clear and send to landing
      localStorage.clear();
      navigate('/');
    }
  }, [navigate]);

  const handleClearSession = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="logo-container">
          <img 
            src="/images/symbols/logo-light.png" 
            alt="Agyapadie Vault" 
            className="logo-image" 
          />
        </div>
        
        <div className="verify-prompt-icon">📧</div>
        <h2 className="verify-prompt-title">Verify Your Email Address</h2>
        
        <p className="verify-prompt-message">
          We sent a verification link to your email address.
          Please check your inbox and click the verification link to activate your account.
        </p>
        
        <div className="verify-prompt-note">
          <p>📌 Didn't receive the email?</p>
          <p>Check your spam folder or <Link to="/contact" className="verify-prompt-link">contact support</Link>.</p>
        </div>
        
        <Link to="/login" className="btn-primary verify-prompt-btn">
          Back to Login
        </Link>
        
        <button onClick={handleClearSession} className="verify-prompt-clear">
          Not You? Clear Session
        </button>
      </div>
    </div>
  );
};

export default VerifyPrompt;